import api from './api';

export type AgentAiStatusData = {
  gemmaAvailable: boolean;
  sparkConfigured: boolean;
  sparkReachable: boolean;
  sparkError?: string;
  sparkPingError?: string;
  /** Ustawiony SPARK_GEMMA_BASE_URL (31B) */
  spark31Configured?: boolean;
  /** Ustawiony SPARK_GEMMA_26B_BASE_URL */
  spark26Configured?: boolean;
  spark26Reachable?: boolean;
  spark26PingError?: string;
  /** Ustawiony SPARK_QWEN_BASE_URL */
  sparkQwenConfigured?: boolean;
  sparkQwenReachable?: boolean;
  sparkQwenPingError?: string;
};

export async function fetchAgentAiStatus(): Promise<AgentAiStatusData | null> {
  try {
    const r = await api.get<{ success?: boolean; data?: AgentAiStatusData }>('/ai/agent/status');
    if (!r.data?.success || !r.data?.data) return null;
    return r.data.data;
  } catch {
    return null;
  }
}
